export const programComparisonDict = {
  en: {
    selectProgramsForComparison: 'Select programs for comparison',
    selectCountry: 'Select country',
    close: 'Close',
    caribbean: 'Caribbean',
    europe: 'Europe',
    oceania: 'Oceania',
    middleEast: 'Middle East',
    americas: 'Americas',
    asia: 'Asia',
    overview: 'Overview',
    status: 'Status',
    obtainingPeriod: 'Timeframe',
    residencyAfterStatus: 'Residing in the country after obtaining the status',
    submitBiometrics: 'Visit the country to submit biometrics',
    travelFreedom: 'Travel freedom',
    visafreeCountries: 'Visa-free countries',
    visafreeSchengen: 'Visa-free Schengen Area',
    usa: 'Visa-free USA',
    uk: 'Visa-free UK',
    australia: 'Visa-free Australia',
    benefits: 'Benefits',
    familyParticipation: 'Participation of family members',
    addFamilyMembers: 'Adding new family members',
    heritability: 'Heritability',
    euRightsLivingStudyWork: 'Right to live, study, and work in any EU country',
    taxResidencyChange: 'Change of tax residency',
    dualCitizenshipAllowed: 'Dual citizenship is allowed in the country',
    expenses: 'Expenses',
    investmentAmount: 'Investment amount',
    investmentOptions: 'Investment options',
    totalExpensesApplicant: 'Total expenses for 1 applicant',
    totalExpensesFamily: 'Total expenses for a family of 4',
    investmentHoldingPeriod: 'Investment holding period',
    investmentReturnPeriod: 'Investment return period',
    sponsorship: 'Sponsorship',
    totalExpenses: 'Total expenses depend on the number of family members',
    issuedDocument: 'Issued document',
    documentType: 'Document type',
    validity: 'Validity',
    featuresAndNuances: 'Features and nuances',
    receivingMaintainingConditions: 'Conditions for receiving and maintaining',
    downloadGuide: 'Download a guide',
    calculateCost: 'Calculate the cost',
  },
  ru: {
    selectProgramsForComparison: 'Выберите программы для сравнения',
    selectCountry: 'Выбрать страну',
    close: 'Закрыть',
    caribbean: 'Карибы',
    europe: 'Европа',
    oceania: 'Океания',
    middleEast: 'Средний восток',
    americas: 'Америка',
    asia: 'Азия',
    overview: 'Основные условия',
    status: 'Статус',
    obtainingPeriod: 'Сроки получения',
    residencyAfterStatus: 'Обязательно жить в стране после получения статуса',
    submitBiometrics: 'Нужно приехать в страну и сдать биометрию',
    travelFreedom: 'Путешествия без виз',
    visafreeCountries: 'Безвизовые страны',
    visafreeSchengen: 'Шенгенская зона',
    usa: 'США',
    uk: 'Великобритания',
    australia: 'Австралия',
    benefits: 'Преимущества',
    familyParticipation: 'Статус для всей семьи',
    addFamilyMembers: 'Присоединение новых членов семьи',
    heritability: 'Статус передается по наследству',
    euRightsLivingStudyWork: 'Право жить, учиться и работать в странах ЕС',
    taxResidencyChange: 'Условия приобретения налогового резидентства',
    dualCitizenshipAllowed: 'Отказ от первого гражданства',
    expenses: 'Расходы',
    investmentAmount: 'Сумма инвестиций',
    investmentOptions: 'Оптимальный вариант инвестиций',
    totalExpensesApplicant: 'Расходы на 1 заявителя',
    totalExpensesFamily: 'Расходы на семью из 4 человек',
    investmentHoldingPeriod: 'Срок владения объектом инвестиций',
    investmentReturnPeriod: 'Срок возврата инвестиций',
    sponsorship: 'Оплата инвестиции спонсором',
    totalExpenses: 'Итоговая сумма зависит от участия членов семьи',
    issuedDocument: 'Получаемый документ',
    documentType: 'Тип документа',
    validity: 'Срок действия',
    featuresAndNuances: 'Особенности статуса',
    receivingMaintainingConditions: 'Условия получения и поддержания',
    downloadGuide: 'Скачать руководство',
    calculateCost: 'Рассчитать стоимость',
  },
};
